import {FAILURE, REQUEST, SUCCESS} from './action-type';
import axios from 'axios';
import moment from 'moment';
import {
  mdFetchUserFulfilled,
  mdFetchWeighInDetails,
  mdFetchWeighInDetailsFulfilled } from './macroData';


export const ACTION_TYPES = {
  GET_TRACKER_DATA: 'friendTracker/GET_TRACKER_DATA',
  UPDATE_SELECTED_DAY: 'friendTracker/UPDATE_SELECTED_DAY',
  GET_WEIGH_IN_DETAILS: 'friendTracker/GET_WEIGH_IN_DETAILS',
  GET_PROFILE: 'friendTracker/GET_PROFILE',
  SET_FRIEND: 'friendTracker/SET_FRIEND',
  COPY_FRIEND_ITEMS: 'friendTracker/COPY_FRIEND_ITEMS',
  UPDATE_LOCAL_TIMELINE: 'friendTracker/UPDATE_LOCAL_TIMELINE',
  RESET: 'friendTracker/RESET',
};

const initialState = {
  friendshipObject: {
    id: null,
    friend_id: null,
    full_name: '',
    avatar_thumb_url: '',
  },
  friendProfile: {},
  macroData: {},
  loading: false,
  selectedDay: moment().local().format('YYYY-MM-DD'),
  timeline: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_PROFILE):
    case REQUEST(ACTION_TYPES.GET_TRACKER_DATA):
      return {
        ...state,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.GET_WEIGH_IN_DETAILS):
      return {
        ...state,
        loading: true,
        macroData: mdFetchWeighInDetails(
          state.macroData,
          action.meta.dateString,
        ),
      };
    case SUCCESS(ACTION_TYPES.GET_PROFILE):
      return {
        ...state,
        loading: false,
        friendProfile: action.payload.data.profile,
        macroData: mdFetchUserFulfilled(
          state.macroData,
          action.payload.data.profile,
        ),
      };
    case SUCCESS(ACTION_TYPES.GET_TRACKER_DATA):
      if (action.payload.data.timeline) {
        return {
          ...state,
          timeline: {...state.timeline, ...action.payload.data.timeline},
          favorites: action.payload.data.favorites,
          loading: false,
        };
      } else {
        return {
          ...state,
          loading: false,
        };
      }
    case SUCCESS(ACTION_TYPES.GET_WEIGH_IN_DETAILS):
      return {
        ...state,
        loading: false,
        macroData: mdFetchWeighInDetailsFulfilled(
          state.macroData,
          action.payload.data,
        ),
      };
    case ACTION_TYPES.UPDATE_SELECTED_DAY:
      return {
        ...state,
        selectedDay: action.selectedDay,
      };
    case ACTION_TYPES.SET_FRIEND:
      return {
        ...state,
        friendshipObject: action.friendshipObject,
        macroData: {},
        timeline: {},
      };
    case FAILURE(ACTION_TYPES.GET_WEIGH_IN_DETAILS):
    case FAILURE(ACTION_TYPES.GET_TRACKER_DATA):
    case FAILURE(ACTION_TYPES.GET_PROFILE):
      return {
        ...state,
        loading: false,
      };
    case ACTION_TYPES.RESET:
      return {...initialState};
    default:
      return state;
  }
};

